module.exports = __webpack_public_path__ + "img/conhome-full-logo-dark.b125973d.svg";